import { initReactI18next } from 'react-i18next'
import { locales } from '@nginformatica/quirons-i18n'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: false,
        fallbackLng: 'pt',
        defaultNS: 'common',
        supportedLngs: ['pt'],
        load: 'languageOnly',
        interpolation: {
            escapeValue: false
        },
        resources: { ...locales },
        returnEmptyString: false
    })

export default i18n
